import { http } from '~/lib/http'
import { Res } from '~/types/common'
import { Language, LanguagePayload, LanguageStatusQuery } from '~/types/language'

const buildStatusQuery = (status: LanguageStatusQuery = 'all') => {
    const query = new URLSearchParams()
    query.set('status', status)
    return `?${query.toString()}`
}

const languageApi = {
    getActiveLanguages: async () => {
        return (await http.get<Res<Language[]>>('/languages')).data
    },
    getActiveLanguageById: async (id: string) => {
        return (await http.get<Res<Language>>(`/languages/${id}`)).data
    },
    getManagerLanguages: async ({ status = 'all' }: { status?: LanguageStatusQuery } = {}) => {
        return (await http.get<Res<Language[]>>(`/manager/languages${buildStatusQuery(status)}`)).data
    },
    getManagerLanguageById: async (id: string) => {
        return (await http.get<Res<Language>>(`/manager/languages/${id}`)).data
    },
    createLanguage: async (data: LanguagePayload) => {
        return await http.post<Res<null>>('/manager/languages', data)
    },
    updateLanguage: async (id: string, data: LanguagePayload) => {
        return await http.put<Res<null>>(`/manager/languages/${id}`, data)
    },
    deleteLanguage: async (id: string) => {
        return await http.delete<Res<null>>(`/manager/languages/${id}`)
    }
}

export default languageApi
